import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../store";
import { post } from "../../../services/API/ApiClient";
import { DefaultArchivedRequestBodyType } from "../../../constant/document";
import { autoRefreshFrequency } from "../../../constant/constant";

export const fetchArchivedAudios = createAsyncThunk<any, any, { state: RootState }>("transcribe/fetchArchivedAudios", async (args, { getState, dispatch, rejectWithValue }) => {
  try {
    const reqBody = {
      ...getState().ArchivedAudiosState.currentRequestBody,
      ...getState().TranscribeState.filterValues,
      StatusId: 5,
      Keyword: getState().TranscribeState.searchKeyword,
    };
    dispatch(updateArchivedRequestBody(reqBody));

    const response = await post("/packs/search", "Transcribe", reqBody);
    return response.data.results;
  } catch (e) {
    return rejectWithValue(e);
  }
});

export const fetchPaginateArchivedAudios = createAsyncThunk<any, any, { state: RootState }>("transcribe/fetchPaginateArchivedAudios", async (args, { getState, dispatch, rejectWithValue }) => {
  try {
    const reqBody = {
      ...getState().ArchivedAudiosState.currentRequestBody,
      PageNum: getState().ArchivedAudiosState.pagination.page,
    };
    const response = await post("/packs/search", "Transcribe", reqBody);

    return {
      data: response.data.results,

      hasMore: response.data.results.length > 0,
    };
  } catch (e) {
    return rejectWithValue(e);
  }
});

//Fetching the RefreshArchived

export const fetchRefreshArchived = createAsyncThunk<any, any, { state: RootState }>("transcribe/fetchRefreshArchivedTenants", async (args, { getState, dispatch, rejectWithValue }) => {
  const currentDataLength = getState().ArchivedAudiosState.data.length === 0 ? 30 : getState().ArchivedAudiosState.data.length;
  try {
    const reqBody = {
      ...getState().ArchivedAudiosState.currentRequestBody,
      pageSize: Math.ceil(currentDataLength / 30) * 30,
    };

    const response = await post("/packs/search", "Transcribe", reqBody);
    return response.data.results;
  } catch (e) {
    return rejectWithValue(e);
  }
});

//Auto Refreshing the Archived Audios
export const autoRefreshArchivedAudios = createAsyncThunk<any, any, { state: RootState }>("transcribe/autoRefreshArchivedAudios", async (args, { getState, dispatch, rejectWithValue }) => {
  if (getState().ArchivedAudiosState.autoRefreshArchivedState.currentIntervalId) {
    clearInterval(getState().ArchivedAudiosState.autoRefreshArchivedState.currentIntervalId);
  }
  if (getState().ArchivedAudiosState.autoRefreshArchivedState.autoRefresh) {
    const intervalId = setInterval(() => {
      dispatch(fetchRefreshArchived({}));
    }, autoRefreshFrequency);
    dispatch(setArchivedAutoRefresh({ intervalId }));
  }
});

//Search ArchivedAudios
export const searchArchivedAudios = createAsyncThunk<any, { searchKeyword: string }, { state: RootState }>("transcribe/searchArchivedAudios", async (args, { getState, dispatch }) => {
  dispatch(resetArchivedTable());
  dispatch(updateArchivedRequestBody({ ...getState().ArchivedAudiosState.currentRequestBody, Keyword: getState().TranscribeState.searchKeyword }));
  dispatch(fetchArchivedAudios({}));
});

//Start the generic action for Tenants
export const resetArchivedTable = createAction("transcribe/resetArchivedTable");
export const updateArchivedRequestBody = createAction<DefaultArchivedRequestBodyType>("transcribe/updateArchivedRequestBody");
export const stopArchivedAutoRefresh = createAction("transcribe/stopArchivedAutoRefresh");
export const setArchivedAutoRefresh = createAction<{ intervalId: NodeJS.Timer }>("transcribe/setArchivedAutoRefresh");
export const switchArchivedAutoFresh = createAction<{ autoRefresh: boolean }>("transcribe/switchArchivedAutoFresh");
//End the generic action for Tenants

//THE STATIC METHOD OF FILTERING

//FilterArchivedAudiosTeanants
export const filterArchivedAudiosTenants = createAsyncThunk<any, { filterTenant: string }, { state: RootState }>("transcribe/searchArchivedAudios", async (args, { getState, dispatch }) => {
  const tenantMapping: Record<string, number> = {
    "Ernest Young": 3,
    "Williams Lea": 4,
    "Wright Hassall": 2,
    Tenant234: 7,
    Organization: 0,
  };

  // Get the corresponding Tenant ID from the mapping
  const tenantId = tenantMapping[args.filterTenant];
  // console.log(tenantId)

  // if (!tenantId) {
  //   console.error("Tenant ID not found for:", args.filterTenant);
  //   return;
  // }

  // Dispatch actions with the correct TenantId
  dispatch(resetArchivedTable());
  dispatch(
    updateArchivedRequestBody({
      ...getState().ArchivedAudiosState.currentRequestBody,
      TenantId: tenantId,
    })
  );
  dispatch(fetchArchivedAudios({}));
});
